// Define a constant for the UPDATE_TEXT action type
export const ACTION_TYPES = {
  ADD_SOLUTION: "ADD_SOLUTION",
  REMOVE_SOLUTION: "REMOVE_SOLUTION",
  SUBMIT_ANSWER: "SUBMIT_ANSWER",
  SET_ASSAY_PREDICTION: "SET_ASSAY_PREDICTION",
};

export const addSolutionToAssayPrediction = (data) => {
  //data = { solution }
  return { type: "ADD_SOLUTION", payload: data };
};

export const removeSolutionFromAssayPrediction = (data) => {
  //data = { solution }
  return { type: "REMOVE_SOLUTION", payload: data };
};

export const submitAnswer = (data) => {
  //data = { solution }
  return { type: "SUBMIT_ANSWER", payload: data };
};

export const setAssayPrediction = (data) => {
  //data = { solution }
  return { type: "SET_ASSAY_PREDICTION", payload: data };
};

export const setPredictionValidation = (data) => {
  //data = {id, prediction}
  return { type: "SET_PREDICTION", payload: data };
};
